import { ApiImpl } from "./ServiceImpl";

export const Service = (api: ApiImpl) => {
    const getTodoTaskNumber = async (params: any) => {
        const response = await api.getTodoTaskNumber(params);
        const total = response.results?.reduce((total: number, curr: any) => {
            return total + curr.count;
        }, 0)
        return {
            total: total || 0,
            todoCategoryList: response.results || []
        }
    }
    return { getTodoTaskNumber }
}